<template>
	<div class="table w-0 rounded bg-white px-2 py-1">
		<span
			class="rounded bg-white px-2 text-xs leading-6 font-bold whitespace-nowrap md:text-sm md:leading-7"
		>
			{{ tag }}
		</span>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	tag: string | number | boolean;
}>();
</script>
